var _jsxFileName = "/runner/_work/smpackages/smpackages/packages/webassets/src/components/AccountCard/AccountTypeBadge/AccountTypeBadge.tsx",
  _this = this;
import React from 'react';
import { isEnterprisePackage } from '@sm/utils';
import getPackageName from '../../../helpers/packageHelpers';
import { withWebAssetsTheme } from '../../../theme';
import useStyles from './useStyles';
var AccountTypeBadge = function AccountTypeBadge(_ref) {
  var packageId = _ref.packageId,
    teamName = _ref.teamName;
  var _useStyles = useStyles({
      packageId: packageId
    }),
    badge = _useStyles.badge;
  return /*#__PURE__*/React.createElement("span", {
    "data-testid": "AccountTypeBadge",
    className: badge,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 16,
      columnNumber: 5
    }
  }, !!teamName && isEnterprisePackage(packageId) ? teamName : getPackageName(packageId));
};
export default withWebAssetsTheme(AccountTypeBadge);
//# sourceMappingURL=AccountTypeBadge.js.map